/** Account Page Design decision map, FigJam node 87:228. */
export const SEGMENTS = [
    'business_support',
    'offer_ready',
    'share_bs',
    'apply'
] as const;

export type TDashboardSegment = (typeof SEGMENTS)[number];

/** Only offer_ready varies; backend defaults the other segments to 'standard'. */
export type TSegmentEmphasis = 'standard' | 'strong';

// TODO(TRT-2400): discriminate this on `segment`. headroom is absent for
// business_support and non-null for offer_ready, and emphasis only applies to
// offer_ready. Needs the guard to enforce the branches, or the type lies.
export type TDashboardSegmentResponse = {
    segment: TDashboardSegment | null;
    /**
     * Additional funds, not the total limit. Firm for offer_ready, indicative
     * for share_bs and apply.
     */
    headroom: number | null;
    emphasis: TSegmentEmphasis;
    /**
     * ISO 8601. Moves only when `segment` changes, so it measures time in the
     * current segment. Null when the backend has no entry date for the customer.
     */
    segment_entered_at: string | null;
};
